import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/67/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorMicroarea(cod_ibge, nu_ine, microarea) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/67/equipe/${nu_ine}/micro-area/${microarea}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    // HPV
    const coresHpv = [
      {
        dose: '1ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: '2ª DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: 'ÚNICA',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const primeiraDoseHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '1'
    )
    const segundaDoseHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '2'
    )
    const doseUnicaHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '9'
    )

    if (primeiraDoseHpv.tipo == 'aplicada') {
      coresHpv[0].cor = 'green'
      coresHpv[0].dt_aplicacao_br = primeiraDoseHpv.dt_aplicacao_br
      coresHpv[0].dose_anterior = primeiraDoseHpv.dose_anterior
    } else {
      coresHpv[0].cor = 'white'
      coresHpv[0].dt_aplicacao_br = ''
      coresHpv[0].sg_d = primeiraDoseHpv.sg_d
      coresHpv[0].sg_im = primeiraDoseHpv.sg_im
    }

    if (segundaDoseHpv.tipo == 'aplicada') {
      coresHpv[1].cor = 'green'
      coresHpv[1].dt_aplicacao_br = segundaDoseHpv.dt_aplicacao_br
      coresHpv[1].dose_anterior = segundaDoseHpv.dose_anterior
    } else {
      coresHpv[1].cor = 'white'
      coresHpv[1].dt_aplicacao_br = ''
      coresHpv[1].sg_d = segundaDoseHpv.sg_d
      coresHpv[1].sg_im = segundaDoseHpv.sg_im
    }

    if (doseUnicaHpv.tipo == 'aplicada') {
      coresHpv[2].cor = 'green'
      coresHpv[2].dt_aplicacao_br = doseUnicaHpv.dt_aplicacao_br
      coresHpv[2].dose_anterior = doseUnicaHpv.dose_anterior
    } else {
      coresHpv[2].cor = doseUnicaHpv.cor
      coresHpv[2].dt_aplicacao_br = '9 a 14 anos'
      coresHpv[2].sg_d = doseUnicaHpv.sg_d
      coresHpv[2].sg_im = doseUnicaHpv.sg_im
    }

    return {
      index: index,
      ...item,
      coresHpv,
    }
  })
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
        id_dose_imuno: doseAplicada.id_dose_imuno,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

export function exibirVermelhos(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresHpv.find((element) => element.cor === 'red') ||
      item.coresHpv.every((element) => element.cor === 'white')
    ) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresHpv.find(
        (element) => element.cor !== 'red' && element.cor !== 'white'
      ) ||
      item.coresHpv.every((element) => element.cor === 'green')
    ) {
      return true
    }
  })
  return filtro
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'HPV Quadrivalente'
  let titlePdfSave = utils.methods.titlePdf(
    'HPV Quadrivalente',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Situação vacinal de crianças com HPV Quadrivalente'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'MA', 'CADASTRADO POR', 'HPV']
  var data_pdf = []
  let doses = formatarCadastrosComDoses(cadastros)
  for (let i = 0; i < doses.length; i++) {
    let obj = {}
    obj.no_cidadao = doses[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(doses[i].dt_nascimento)
    obj.no_mae = doses[i].no_mae
    obj.ma = doses[i].micro_area
    obj.cadastrado_por = doses[i].profissional
    obj.hpv = ''

    let coresHpv = doses[i].coresHpv
    let validDates = coresHpv.filter(
      (obj) =>
        obj.dt_aplicacao_br &&
        obj.dt_aplicacao_br.trim() !== '' &&
        obj.dt_aplicacao_br != '9 a 14 anos'
    )
    if (validDates.length === 0) {
      obj.hpv = ''
    } else {
      let maiorDose = validDates.reduce((maior, atual) => {
        let [dia, mes, ano] = atual.dt_aplicacao_br.split('/')
        let dataAtual = new Date(ano, mes - 1, dia)
        return dataAtual > maior ? dataAtual : maior
      }, new Date(0))

      let formatarData = (data) => {
        let dia = String(data.getDate()).padStart(2, '0')
        let mes = String(data.getMonth() + 1).padStart(2, '0')
        let ano = data.getFullYear()
        return `${dia}/${mes}/${ano}`
      }
      obj.hpv = formatarData(maiorDose)
    }
    data_pdf.push(obj)
  }
  let doc = new jsPDF({ orientation: 'l', ...utils.methods.encryptionPdf() })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)
  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 8,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 8,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdfCentralizado(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Cadastrado por': 'profissional',
  HPV: {
    callback: (item) => {
      let coresHpv = item.coresHpv
      let validDates = coresHpv.filter(
        (obj) =>
          obj.dt_aplicacao_br &&
          obj.dt_aplicacao_br.trim() !== '' &&
          obj.dt_aplicacao_br != '9 a 14 anos'
      )
      if (validDates.length === 0) {
        return ''
      } else {
        let maiorDose = validDates.reduce((maior, atual) => {
          let [dia, mes, ano] = atual.dt_aplicacao_br.split('/')
          let dataAtual = new Date(ano, mes - 1, dia)
          return dataAtual > maior ? dataAtual : maior
        }, new Date(0))

        let formatarData = (data) => {
          let dia = String(data.getDate()).padStart(2, '0')
          let mes = String(data.getMonth() + 1).padStart(2, '0')
          let ano = data.getFullYear()
          return `${dia}/${mes}/${ano}`
        }
        return formatarData(maiorDose)
      }
    },
  },
}

export const filterIdadeOptions = [
  { label: '9 - 14 anos', value: '9 - 14 anos' },
  { label: '15 - 19 anos', value: '15 - 19 anos' },
]

export function handleFilterIdade(data, filter) {
  let filtrado = data.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter === '9 - 14 anos') {
      return Number(item.idade_anos) >= 9 && Number(item.idade_anos) <= 14
    } else if (filter === '15 - 19 anos') {
      return Number(item.idade_anos) >= 15 && Number(item.idade_anos) <= 19
    } else {
      return item
    }
  })
  return filtrado
}
